import React from "react";

import ResourcesGridCell from "./resources-grid-cell";

import "../../styles/resources/resources-grid.scss";

class ResourcesGrid extends React.Component {
  render() {
    return (
      <ul className="resources-grid">
        {this.props.resources.map((resource, idx) => (
          <ResourcesGridCell key={idx}
            headline={resource.data.Headline}
            creator={resource.data.Creator}
            illustrator={resource.data.Illustrator}
            year={(resource.data.Fuzzy_Year) ? resource.data.Fuzzy_Year : resource.data.Canonical_Year}
            category={resource.data.Category}
            notes={resource.data.Notes}
            links={resource.data.Links}
            essays={resource.data.Essays}
            essayContext={this.props.essayContext}
          />
        ))}
      </ul>
    );
  }
}

export default ResourcesGrid;